import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { menuLinks } from '../../redux/selectors'
import { useMediaQuery } from 'react-responsive'


const NavLinks = () => {
   const isNotDesktop = useMediaQuery({ query: '(max-width: 1199.98px)' })
   const headerLinks = useSelector(menuLinks)

   if (isNotDesktop) return null

   return (
      <nav className='header__nav'>
         {headerLinks.map(({ title, url }) =>
            <NavLink to={`products/${url}`} key={url}>{title}</NavLink>
         )}
      </nav>
   )
}

export default NavLinks
